import { useTranslation } from 'react-i18next';
import { Badge, type BadgeVariant } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const OTHER_DOCUMENT_TYPE_CODE = 'other';

function variantForDocumentTypeCode(code: string): BadgeVariant {
  return code === OTHER_DOCUMENT_TYPE_CODE ? 'gray' : 'blue';
}

type PurchaseOrderDocumentTypeBadgeProps = {
  documentTypeCode: string;
  className?: string;
};

export function PurchaseOrderDocumentTypeBadge({
  documentTypeCode,
  className,
}: PurchaseOrderDocumentTypeBadgeProps) {
  const { t } = useTranslation('purchaseOrder');
  const variant = variantForDocumentTypeCode(documentTypeCode);
  const label = t(`documentTypeCodes.${documentTypeCode}`, {
    defaultValue: documentTypeCode,
  });

  return (
    <Badge
      className={cn('rounded-full px-4 py-1 font-medium text-xs', className)}
      variant={variant}
    >
      {label}
    </Badge>
  );
}
